import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';

const About = ({
  hotelDetails,
  doShowAgentCommission,
  headerClassName,
}) => {
  const hotelDetailsInfo = useMemo(() => {
    const detailsInfo = hotelDetails && hotelDetails.info && hotelDetails.info.replace(/<pre class="description" style="white-space: break-spaces;">/g, '<div class="description" style="white-space: break-spaces;">').replace(/<\/pre>/g, '</div>');
    if (!doShowAgentCommission) {
      return detailsInfo && detailsInfo.replace("id='hotelCommission'", "id='hotelCommission' style='display:none'");
    }
    return detailsInfo;
  }, [doShowAgentCommission, hotelDetails]);
  return (
    <div>
      <div className={headerClassName}>
        About
      </div>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: hotelDetailsInfo }} className="sm:break-normal break-words" />
    </div>
  );
};

About.propTypes = {
  hotelDetails: PropTypes.shape().isRequired,
  doShowAgentCommission: PropTypes.bool,
  headerClassName: PropTypes.string,
};

About.defaultProps = {
  doShowAgentCommission: true,
  headerClassName: 'font-bold',
};

export default memo(About);
